
import store from '@/vuex/store'
import router from '@/router'
import * as types from './vuex/types'
import { Message } from 'element-ui'

const whiteListRouters = store.getters['permission/whiteListRouters']

router.beforeEach(async (to, from, next) => {
  const sid = store.state['sessionId']
  if (sid && whiteListRouters.indexOf(to.path) == -1) {
    if (to.path === '/login') {
      setTimeout(() => {
        store.commit(types.LOGOUT)
        // store.dispatch('permission/restore');
      })
      next()
      return
    }

    const roles = store.getters['roles']
    if (roles && roles.length > 0) {
      let hasPer = store.getters.userInfo.auth_list.some((item) => {
        return to.path.indexOf(item) > -1
      })
      if (store.getters.userInfo.auth_list.includes(to.path) || to.meta.isCompany) {
        next()
      } else if (to.meta.next) {
        next(to.meta.next)
      } else if (whiteListRouters.indexOf(to.path) !== -1) {
        next()
      } else if (hasPer) {
        next()
      } else {
        Message.error({
          message: '请联系管理员分配权限',
          showClose: true
        })
        next(`/login`)
      }
    } else {
      try {
        await store.dispatch('getUserInfo')
        await store.dispatch('permission/initRoutes', store.getters['userInfo'])
        next({ ...to })
      } catch (error) {
        store.commit(types.LOGOUT)
        next(`/login`)
      }
    }
  } else {
    if (sid && sid != 'undefined') {
      await store.dispatch('getUserInfo')
      await store.dispatch('permission/initRoutes', store.getters['userInfo'])
    }
    /* white list router */
    if (whiteListRouters.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login`)
    }
  }
})

router.afterEach(() => {
})



// WEBPACK FOOTER //
// ./src/permission.js